import axios from 'axios'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from '../Redux/Store';
import { clearToken } from '../Redux/Reducers/GlobalVar';

let toastShown = false


const instance = axios.create({
  // baseURL: process.env.REACT_APP_BASE_URL || 'https://www.complyco.com.au/',

  headers: {
    'Content-Type': 'application/json'
  }
})

instance.interceptors.request.use(
  (config) => {
    const tokenObj = store?.getState()?.global?.token; // object { token: string }
    const token = tokenObj?.token; // string inside object
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
)

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.status == 600) {
      handleLogout()
    }
    return Promise.reject(error)
  }
)
const handleLogout = () => {
  if (!toastShown) {
    toastShown = true;
    store.dispatch(clearToken());
    toast.error("Your session has expired. Please log in again.", {
      autoClose: 2000,
      onClose: () => {
        toastShown = false;
      },
    });
  }
};


export default instance
